import {Lesson, newCourse} from 'api/course'
import {Grade} from 'api/org'
import {IAction} from 'models'

const Action = {
  UpdateSemester: 'UpdateSemester',
  UpdateCourse: 'UpdateCourse',
  SetCurrentCourse: 'SetCurrentCourse',
  SetCourseTotal: 'SetCourseTotal',
  SetCurrentGrade: 'SetCurrentGrade',
}

export interface ICourse {
  semester?: number
  currentCourse?: Lesson
  total?: number
  currentGrade?: Grade
}

const initICourse: ICourse = {
  semester: 1,
  currentCourse: newCourse(),
  total: 0,
}

export const UpdateSemester = (semester: number): IAction<ICourse> => ({
  type: Action.UpdateSemester,
  payload: {...initICourse, semester: semester},
})

export const SetCurrentCourse = (course: Lesson): IAction<ICourse> => ({
  type: Action.SetCurrentCourse,
  payload: {...initICourse, currentCourse: course},
})
export const SetCurrentGrade = (g: Grade): IAction<ICourse> => ({
  type: Action.SetCurrentGrade,
  payload: {currentGrade: g},
})

export const SetCourseTotal = (total: number): IAction<ICourse> => ({
  type: Action.SetCourseTotal,
  payload: {...initICourse, total: total},
})

const reducer = (state = initICourse, action: IAction<ICourse>): ICourse => {
  switch (action.type) {
    case Action.UpdateSemester:
      if (action.payload === undefined) {
        return state
      }

      return {
        ...state,
        semester: action.payload.semester,
      }

    case Action.SetCurrentCourse:
      if (action.payload === undefined) {
        return state
      }

      return {
        ...state,
        currentCourse: action.payload.currentCourse,
      }

    case Action.SetCourseTotal:
      if (action.payload === undefined) {
        return state
      }
      return {
        ...state,
        total: action.payload.total,
      }
    case Action.SetCurrentGrade:
      return {
        ...state,
        currentGrade: action.payload?.currentGrade,
      }

    default:
      return state
  }
}

export default reducer
